<div class="flex flex-col gap-8 p-10">
  <div class="flex items-center justify-between font-bold">
    <h3>{{ "medicalDocuments.label.uploadingModalTitle" | translate }}</h3>
    <button mat-dialog-close>
      <mat-icon
        aria-hidden="true"
        aria-label="Close icon"
      >close</mat-icon>
    </button>
  </div>

  <div>
    <shared-warning-message
      [type]="warningTypes.Error"
      [text]="data.message"
      [subText]="data.additionalText"
    ></shared-warning-message>
  </div>

  <div class="flex items-center justify-end gap-6">
    <button
      mat-dialog-close
      class="btn text-neutral-300 underline hover:bg-neutral-100"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      class="btn btn-primary"
      (click)="closeModal('tryAnother')"
    >
      {{ "medicalDocuments.buttons.tryAnotherFile" | translate }}
    </button>
  </div>
</div>
